import TwigBuilder from '../../Library/TwigBuilder.js';

const attachEditor = field => {
    const carrier = field.closest('[data-export-template-shape]');
    const shape   = JSON.parse(carrier.dataset.exportTemplateShape);

    TwigBuilder.attach(field, {
        data: shape.context,
        labels: JSON.parse(carrier.dataset.twigLabels),
        filters: shape.filters,
        addButtonLabel: '{{',
        openMenuOnBraces: true,
        fieldTypes: shape.types,
        dateTimeFormat: shape.dateTimeFormat,
    });
};

export const initializeTemplateEditors = root => {
    root.querySelectorAll('[data-export-twig-field]').forEach(field => {
        if (TwigBuilder.get(field) || field.closest('[hidden]')) {
            return;
        }

        attachEditor(field);
    });
};
